import React from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { GallectionType } from '@wix/da-shared-react/pkg/types/gallection';
import FolderContent from '../FolderContent';
import FolderBarFolderDropdown from '../FolderBar/_partials/FolderBarFolderDropdown';
import WidgetHeaderMobile from '../../../UserWidgets/_partials/WidgetHeaderMobile';
import SearchField from '../SearchField';

import profilesCssVars from '../../../../styles/variables.scss';
import s from './GallectionSimpleView.scss';

export interface Props {
  currentFolder?: PapiGallection;
}

const MobileGallectionSimpleView: React.FC<Props> = ({ currentFolder }) => {
  const noFavouritesSearch = useFlag('no_favourites_search');

  const isGallery = currentFolder?.type === GallectionType.GALLERY;
  const disableSearch = !isGallery && noFavouritesSearch;

  return (
    <div className={s['root']}>
      <ErrorBoundary debugComponent="MobileGallectionSimpleView">
        <WidgetHeaderMobile
          isSticky={false}
          rootClassName={s['widget-header-mobile']}
          header={false}
          extras={
            <div className={s['header-extras']}>
              {!disableSearch && <SearchField className={s['search-field']} />}
              <FolderBarFolderDropdown
                offsetTop={
                  parseInt(profilesCssVars['mobile-navbar-height']) - 1
                }
                currentFolder={currentFolder}
                arrowIconSize={IconSize.MEDIUM}
              />
            </div>
          }
        />
        <div id="sub-folder-gallery">
          {currentFolder && (
            <FolderContent
              key={currentFolder?.folderId}
              folderId={currentFolder?.folderId || 0}
            />
          )}
        </div>
      </ErrorBoundary>
    </div>
  );
};
MobileGallectionSimpleView.displayName = 'MobileGallectionSimpleView';

export default MobileGallectionSimpleView;
